module.exports = __webpack_public_path__ + "img/program-icon-2.a915ac2c.png";